import Api from "../../lib/api";

export default class LmsUser {
    constructor(props = {}) {
        this.props = props;
        this._id = props._id;
        this.firstName = props.first_name;
        this.lastName = props.last_name;
        this.phone = props.phone;
        this.email = props.email;
        this.avatarPath = props.avatar;
    }

    get fullName() {
        const result = [];

        if (this.firstName) {
            result.push(this.firstName);
        }

        if (this.lastName) {
            result.push(this.lastName);
        }

        return result.join(' ');
    }

    get avatarUrl() {
        if (!this.avatarPath) {
            return '';
        }

        return `${Api.lmsUrl}/${this.avatarPath}`;
    }
}